import { render, staticRenderFns } from "./CardElementEditAction.vue?vue&type=template&id=0a899ee8"
import script from "./CardElementEditAction.vue?vue&type=script&lang=js"
export * from "./CardElementEditAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports